export default [
  {
    // 工单列表
    path: "setting/take_stock_tip",
    name: "SettingTakeStockTip",
    component: () => import("../pages/setting/TakeStockTipSetting.vue"),
    meta: {
      title: "PC点货提示配置",
    },
  },
  {
    // 质检规则配置
    path: "setting/quality_inspection_rule_setting",
    name: "QualityInspectionRuleSetting",
    component: () =>
      import("../pages/setting/QualityInspectionRuleSetting.vue"),
    meta: {
      title: "质检规则配置",
    },
  },
  {
    // 质检规则配置
    path: "setting/express_account",
    name: "ExpressAccount",
    component: () => import("../pages/setting/ExpressAccount.vue"),
    meta: {
      title: "快递账号配置",
    },
  },
  {
    // 退供配置
    path: "setting/return_task_priority",
    name: "ReturnTaskPriority",
    component: () => import("../pages/setting/ReturnTaskPriority.vue"),
    meta: {
      title: "退供配置",
    },
  },
  {
    path: "setting/push_setting",
    name: "PushSetting",
    component: () => import("../pages/setting/PushSetting.vue"),
    meta: {
      title: "推送配置",
    },
  },
  {
    path: "setting/express-optimization-setting",
    name: "ExpressOptimizationSetting",
    component: () => import("../pages/setting/ExpressOptimizationSetting.vue"),
    meta: {
      title: "使用快递优选地区设置",
    },
  },
  {
    path: "setting/fulfill",
    name: "SupplyFulfillSetting",
    component: () => import("../pages/setting/SupplyFulfillSetting.vue"),
    meta: {
      title: "履约管家配置",
    },
  },
  {
    // 系统配置
    path: "setting/system_field",
    name: "SystemField",
    component: () => import("../pages/setting/SystemField.vue"),
    meta: {
      title: "系统配置",
    },
  },
  {
    // 跨仓调拨设置
    path: "setting/warehouse-transfer-setting",
    name: "WarehouseTransferSetting",
    component: () => import("../pages/setting/WarehouseTransferSetting.vue"),
    meta: {
      title: "跨仓调拨设置",
    },
  },
  {
    path: "setting/tomorrow-transport-setting",
    name: "TomorrowTransportSetting",
    component: () => import("../pages/setting/TomorrowTransportSetting.vue"),
    meta: {
      title: "次日发货设置",
    },
  },
  {
    // 质检次品类型
    path: "setting/defective-category-list",
    name: "DefectiveCategoryList",
    component: () => import("../pages/setting/DefectiveCategoryList.vue"),
    meta: {
      title: "质检次品类型",
    },
  },
  {
    // 售后配置
    path: "setting/sold-out",
    name: "SoldOutSetting",
    component: () => import("../pages/setting/SoldOut.vue"),
    meta: {
      title: "售后配置",
    },
  },
  {
    // 仓采配置
    path: "setting/warehouse-purchase-setting",
    name: "WarehousePurchaseSetting",
    component: () => import("../pages/setting/WarehousePurchaseSetting.vue"),
    meta: {
      title: "仓采配置",
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/setting.js